import React from 'react';
import { RoutePermittedRole } from '@crema/constants/AppEnums';

const NoticeList = React.lazy(() => import('../../modules/notice/List'));

export const NoticeConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/notice',
    element: <NoticeList />,
  },
];
